import { useNavigate } from 'react-router-dom';

import { Carousel, SiteUnitCard } from '@frontend-libs/portal';

import type { SiteUnitListModel } from '@portal-clients/site-unit';

import { FavoriteSiteAction } from '@frontend/components';
import { tApp } from '@frontend/locales';
import { usePortalPublicConfiguration } from '@frontend/portal-public-configuration';
import { routes, useOptionalUser } from '@frontend/utils';

export interface SiteUnitCarouselProps {
  sites: SiteUnitListModel[];
}

export const SiteUnitCarousel = ({ sites }: SiteUnitCarouselProps) => {
  const a11y = tApp.siteUnits.a11y;
  const navigate = useNavigate();
  const config = usePortalPublicConfiguration();

  const { user } = useOptionalUser();

  return (
    <Carousel
      offsetCards
      a11y={{
        firstSlideMessage: a11y.firstSlideMessage(),
        lastSlideMessage: a11y.lastSlideMessage(),
        prevSlideMessage: a11y.previousSlideMessage(),
        nextSlideMessage: a11y.nextSlideMessage(),
        paginationBulletMessage: (index) =>
          a11y.goToSiteUnit({
            index,
          }),
      }}
    >
      {sites.map((site) => (
        <SiteUnitCard
          key={site.id}
          address={site.address}
          displayName={site.externalName}
          description={site.description}
          onClick={() => navigate(routes.siteUnits.site(site.id, false))}
          favoriteComponent={() => (
            <FavoriteSiteAction size="medium" siteUnitId={site.id} />
          )}
          isLoggedIn={user !== undefined}
          addressVisibility={
            config?.layout?.layout?.siteUnit?.address ?? 'streetCity'
          }
          descriptionVisibility={
            config?.layout?.layout?.siteUnit?.description ?? 'show'
          }
          headerImageURL={
            site.headerImage
              ? site.headerImage.imageUrl
              : site.headerImageUrl
                ? site.headerImageUrl
                : undefined
          }
          headerImageAltText={site.headerImage ? site.headerImage.altText : ''}
        />
      ))}
    </Carousel>
  );
};
